var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-full"},[(_vm.load)?_c('Freelancers',{attrs:{"custom":_vm.DummyData,"airtable":_vm.airtable}}):_vm._e(),_c('Terms')],1)}
var staticRenderFns = []

export { render, staticRenderFns }